import { useState } from "react";
import locale from "@bonliva-crm/locale";
import { QualityCheck, QualityCheckProps } from "../quality-check";
import { QualityCheckButton } from "../quality-check-button";
import { CriminalRecordType } from "@bonliva-crm/graphql";
import { CriminalRecordLabels } from "./criminal-record-labels";
import { RequestCriminalRecordCheckModal } from "./request-criminal-record-check-modal";

export function CriminalRecordQualityCheck(props: QualityCheckProps) {
  const { data, consultantData } = props;

  const [open, setOpen] = useState(false);

  if (props.data.Name !== "Belastningsregister") {
    throw new Error(
      "CriminalRecordQualityCheck can only be used for Belastningsregister"
    );
  }

  return (
    <>
      <QualityCheck
        {...props}
        withDefaultStatuses={false}
        renderExtraLabels={() => (
          <CriminalRecordLabels data={data} showComment={props.showComment} />
        )}
        renderExtraAction={() => (
          <QualityCheckButton
            text={locale.Order}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setOpen(true);
            }}
            disabled={open}
            // loading={loading}
          />
        )}
      />

      <RequestCriminalRecordCheckModal
        open={open}
        consultantId={consultantData._id}
        types={[
          CriminalRecordType.School,
          CriminalRecordType.LSS,
          CriminalRecordType.WorkWithOtherKid,
          CriminalRecordType.HomeCareElderlyDisabled,
          CriminalRecordType.MunicipalityLeadingPosition,
          CriminalRecordType.HVB,
          CriminalRecordType.OTHER,
          CriminalRecordType.Norway
        ]}
        qualityCheckName="Belastningsregister"
        qualityTemplate={data.templateName}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
